<script lang="ts">import { page } from "$app/stores";
import { cfgToThemeContentPath } from "@infinitro/config";
import { locale, loggedIn } from "@infinitro/global";
import CdnSeoMarkdownPanel from "./cdn-seo-markdown-panel.svelte";
import { fetchLocaleMarkdownWithEnFallback } from "./fetch-markdown-seo";
export let showMoreButton = true;
$: providerSlug = $page.params.provider ?? "";
$: gameSlug = $page.params.game ?? "";
let htmlContent = "";
let lastModified = "";
$: if ($loggedIn === false && providerSlug && gameSlug) {
	const p = providerSlug;
	const g = gameSlug;
	const loc = $locale;
	fetchLocaleMarkdownWithEnFallback(cfgToThemeContentPath(`/seo/games/${p}/${g}/${g}.${loc}.md`), cfgToThemeContentPath(`/seo/games/${p}/${g}/${g}.en.md`)).then(({ html, lastModified: lm }) => {
		if ($loggedIn !== false || p !== $page.params.provider || g !== $page.params.game || loc !== $locale) {
			return;
		}
		htmlContent = html;
		lastModified = lm;
	});
} else {
	htmlContent = "";
	lastModified = "";
}
</script>

<svelte:head>
	{#if lastModified}
		<meta property="article:modified_time" content={lastModified} />
	{/if}
</svelte:head>

<CdnSeoMarkdownPanel noContainer noTopMargin {htmlContent} {lastModified} {showMoreButton} />
